module.exports = __webpack_public_path__ + "static/media/DSCF6373_PRIMERA_APARICION_319px.adee8fa2.jpg";